import { useAuth } from "../context/AuthContext";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";

const AdminPage = () => {
  const { user, logOut } = useAuth();

  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />
      <div className="page-container">
        <div className="mb-8">
          <h1 className="section-title">Admin Settings</h1>
          <p className="text-gray-500 mt-1">Platform management and configuration.</p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <Link to="/manage-opportunities" className="card group">
            <div className="w-11 h-11 rounded-xl flex items-center justify-center bg-blue-50 text-blue-600 mb-3 group-hover:scale-110 transition-transform">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
            <h3 className="font-semibold text-gray-900">Manage Internships</h3>
            <p className="text-sm text-gray-500 mt-1">Add, edit, or remove internship listings</p>
          </Link>

          <Link to="/manage-hackathons" className="card group">
            <div className="w-11 h-11 rounded-xl flex items-center justify-center bg-green-50 text-green-600 mb-3 group-hover:scale-110 transition-transform">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
            </div>
            <h3 className="font-semibold text-gray-900">Manage Hackathons</h3>
            <p className="text-sm text-gray-500 mt-1">Add, edit, or remove hackathon listings</p>
          </Link>

          <div className="card">
            <div className="w-11 h-11 rounded-xl flex items-center justify-center bg-gray-100 text-gray-500 mb-3">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
              </svg>
            </div>
            <h3 className="font-semibold text-gray-900">User Management</h3>
            <p className="text-sm text-gray-500 mt-1">Coming soon</p>
          </div>
        </div>

        <div className="mt-8 bg-white rounded-xl border border-gray-100 p-6">
          <h2 className="text-lg font-semibold text-gray-900 mb-3">Account Info</h2>
          <div className="space-y-2 text-sm text-gray-600">
            <p><span className="font-medium text-gray-900">Email:</span> {user?.email}</p>
            <p><span className="font-medium text-gray-900">Name:</span> {user?.displayName}</p>
            <p><span className="font-medium text-gray-900">Role:</span> Admin</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminPage;
